<template>
  <div class="v-long-answer container">
    <textarea
      class="v-long-answer__text"
      placeholder="Responda a questão aqui..."
      maxlength="120"
      v-model="value"
    ></textarea>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "VLongAnswer",
  data: () => ({ value: "" }),
  computed: {
    ...mapState("Quiz", ["currentQuestion"])
  },
  methods: {
    ...mapMutations("Quiz", ["updateResponse"])
  },
  watch: {
    value(value) {
      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: value
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";
.v-long-answer {
  &__text {
    min-height: 250px;
    font-size: 24px;
    border: none;
    outline: none;
    background: #d0d0d0;
    border-radius: 8px;
    padding: 16px 32px;
    width: 100%;

    @media #{$small-and-down} {
      min-height: 100px;
      font-size: 16px;
    }

    &::placeholder {
      color: #8c8c8c;
    }
  }
}
</style>
